import './style.css';

export default function Home() {
    return (
            <div className="home-body">
                <h2 contentEditable="true">Lets Code!</h2>
            </div>
    );
}